import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block bg-background-50 rounded-xl border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-primary-300"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={comic.cover}
          alt={comic.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <div className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-medium">
          {comic.rating}
        </div>
        {comic.status === '已完结' && (
          <div className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-accent-500 text-foreground-950 text-xs font-medium">
            已完结
          </div>
        )}
      </div>
      <div className="p-3">
        <h3 className="font-heading text-sm font-semibold text-foreground-950 truncate group-hover:text-primary-600 transition-colors duration-200">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1 truncate">{comic.author}</p>
        <div className="flex items-center justify-between mt-2">
          <span className="text-xs text-foreground-400">{comic.views} 阅读</span>
          <span className="text-xs text-foreground-400">{comic.chapters}话</span>
        </div>
      </div>
    </Link>
  );
}